import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteRelatedProductModel } from 'src/app/models/product/relatdProduct';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { ProductService } from 'src/app/services/product.service';

@Component({
  selector: 'app-related-products-deleted',
  templateUrl: './related-products-deleted.component.html',
  styleUrls: ['./related-products-deleted.component.css']
})
export class RelatedProductsDeletedComponent implements OnInit {
  Loader: boolean = false;
  ProductId: string;
  deleteRelatedProduct: DeleteRelatedProductModel = new DeleteRelatedProductModel();
  constructor(private modalService: NgbModal, private productService: ProductService, private alertify: AlertifyService) { }

  ngOnInit() {
    this.ProductId = this.ProductId;
  }

  onCancel() {
    this.modalService.dismissAll();
  }

  deleteRelatedProducts() {
    this.Loader = true;
    this.deleteRelatedProduct.RelatedProductIds = this.ProductId.toString();
    this.productService.DeleteRelatedProducts(this.deleteRelatedProduct)
      .subscribe(response => {
        var responseBody = JSON.parse(response._body);
        if (responseBody.isSuccess) {
          this.modalService.dismissAll();
          this.alertify.success(responseBody.responseMessage);
          this.Loader = false;
        } else {
          this.Loader = false
        }
      })
  }
}
